var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-chip',_vm._g(_vm._b({},'q-chip',_vm.$attrs,false),_vm.$listeners),[_c('q-avatar',[_c('q-img',{attrs:{"src":_vm.rol.avatar || 'https://static.bienparabien.com/img/Logo_BPB_alt.png'}})],1),_vm._v(" "+_vm._s(_vm.rol.nombre)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }